import { render, staticRenderFns } from "./cmpinformacoescliente.vue?vue&type=template&id=66f6921e&"
import script from "./cmpinformacoescliente.vue?vue&type=script&lang=js&"
export * from "./cmpinformacoescliente.vue?vue&type=script&lang=js&"
import style0 from "./cmpinformacoescliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports